"use client";

import { useEffect } from "react";
import { trackEvent } from "@/lib/tracking";

interface ServiceTrackerProps {
    serviceName: string;
    serviceSlug: string;
    category?: string;
}

export function ServiceTracker({ serviceName, serviceSlug, category = "vize" }: ServiceTrackerProps) {
    useEffect(() => {
        // Track ViewContent for Meta
        trackEvent("ViewContent", {
            content_name: serviceName,
            content_category: category,
            content_ids: [serviceSlug],
            content_type: "product",
        });

        // Track view_item for GA4
        trackEvent("view_item", {
            item_id: serviceSlug,
            item_name: serviceName,
            item_category: category,
        });
    }, [serviceName, serviceSlug, category]);

    return null;
}
